<template>
    <b-modal
            body-class="p-0"
            cancel-disabled
            hide-footer
            id="oow-modal"
            title="">
        <div class="modal-body modal-body-lg pt-0">
            <div>
                <animated-info class="mx-auto mb-4"></animated-info>
            </div>
            <h4 class="text-center mb-4">Your device is out of warranty</h4>
            <p class="text-center" :class="{'mb-4': withRedirect}">
                We can still carry out the repair of your device, but it will not be covered as a free repair under the warranty.
            </p>
            <p class="text-center mb-4" v-if="withRedirect">
                Click 'continue' below to return to the basket to confirm the repairs and their costs.
            </p>
            <p class="text-center">
                <button @click="confirmOow()" class="btn btn-primary btn-lg" :disabled="confirming"><i class="fa fa-spinner fa-pulse" v-if="confirming"></i> Continue</button>
            </p>
        </div>
    </b-modal>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: 'OutOfWarrantyModal',

        props: {
            withRedirect: {
                type: Boolean,
                default: true
            },
        },

        data() {
            return {
                confirming: false
            }
        },

        methods: {
            ...mapActions(['setWarrantyState', 'setWarrantyDetails']),

            confirmOow() {
                this.confirming = true;
                this.setWarrantyState(false).then(() => {
                    this.setWarrantyDetails({purchaseDate: null, imei: null}).then(() => {
                        this.confirming = false;
                        if (this.withRedirect) {
                            this.$router.push({name: 'repairSelect'});
                        } else {
                            this.$bvModal.hide('oow-modal');
                        }
                    });
                });
            }
        }
    }
</script>

<style scoped>

</style>